import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Field = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Label = styled.label`
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 700;
    color: ${colors.fieldLabel};
`;

export const Hint = styled.span<{ $tone: "default" | "danger" }>`
    margin-top: 6px;
    font-size: 12px;
    color: ${({ $tone }) => ($tone === "danger" ? colors.danger : colors.textSecondary)};
`;
